import React from 'react';
import styled from 'styled-components';
import Grid from './grid';
import Highlight from './button';

const ButtonHighlights = ({
  // id,
  highlights,
  variant,
}) => (
  <Grid $variant={variant} $columns={highlights.length}>
    {highlights.map((highlight) => (
      <Highlight key={highlight.id} {...highlight} />
    ))}
  </Grid>
);

export default styled(ButtonHighlights)``;
